import { NgOptimizedImage } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-login-failed',
  imports: [MatProgressSpinnerModule, NgOptimizedImage],
  templateUrl: './login-failed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login-failed.component.css',
})
export class LoginFailedComponent {}
